<mds-message
    data-cy="alert-card"
    [variant]="'section'"
    [appearance]="appearance()"
    [dismissible]="dismissable()"
    [content]="content()"
    (closeMessageEvent)="closeMessageEvent.emit()"
/>
